var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('file-alert-modal',{ref:"fileAlertModal"}),_c('input',{ref:"fileInput",staticClass:"file-input",attrs:{"type":"file"},on:{"change":_vm.onFileUploadChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }